import { PrivacyPolicy } from "landing";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const PrivacyPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Mango GIS - Privacy"
				description="Legal information about Privacy"
			/>
			<PrivacyPolicy />
		</>
	);
};

export default PrivacyPage;
